/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_DescInputs */



/**
* | output |
* | --- |
* | "Configure MIDI settings and ADR preview for audio recording" |
*
* @param {Options_Adr_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_desc = /** @type {((inputs?: Options_Adr_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configurer les paramètres MIDI et l'aperçu ADR pour l'enregistrement audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("MIDI-Einstellungen und ADR-Vorschau für die Audioaufnahme konfigurieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configura le impostazioni MIDI e l'anteprima ADR per la registrazione audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройте параметры MIDI и предварительный просмотр ADR для аудиозаписи.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configurar los ajustes MIDI y la vista previa ADR para la grabación de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("配置 MIDI 设置和 ADR 预览以进行音频录制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ録音のMIDI設定とADRプレビューを構成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो रिकॉर्डिंग के लिए MIDI सेटिंग्स और ADR पूर्वावलोकन को कॉन्फ़िगर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configure as definições MIDI e a pré-visualização ADR para gravação de áudio.")
	return /** @type {LocalizedString} */ ("Configure MIDI settings and ADR preview for audio recording")
});